import _ from "lodash";
import Schema from "components/Schema";

export default function RenderTree({ tree }) {
  // issue #6
  const body = _.get(tree, "body", {});
  return Object.keys(body).map((i) => (
    <Schema key={i} component={body[i]} path={i} level={0} />
  ));
}
